import { EntityTypeEnum, FilterOperation, ProductSector, SubscriptionFilter } from 'api'
import { Locale, Translation } from 'locale'
import React from 'react'
import { useSelector } from 'react-redux'
import { createAllEntitiesSortedSelector } from 'selectors/entitySelectors'
import { allKnownSortedProductSectorIdsSelector } from 'selectors/productSelectors'
import { SelectboxField } from 'view/components/options'
import {
  getProductIdFromProductSectorIdsString,
  getProductSectorIdsBelongingToProduct,
  getProductSectorNameById,
  getSubscriptionFilterValue
} from '../utils'

interface ProductSectorSubscriptionSelectboxProps {
  subscriptionFilters: SubscriptionFilter[]
  handleUpdateFilterValue: (fieldName: string, filterOperation: FilterOperation) => (value: any) => void
}

export const ProductSectorSubscriptionSelectbox: React.FC<ProductSectorSubscriptionSelectboxProps> = ({
  subscriptionFilters,
  handleUpdateFilterValue
}) => {
  const allProductSectors: ProductSector[] = useSelector(createAllEntitiesSortedSelector(EntityTypeEnum.PRODUCT_SECTOR))
  const productSectorIdsFilterValue = getSubscriptionFilterValue(subscriptionFilters, 'productSectorId', FilterOperation.CONTAINS)
  const productId = getProductIdFromProductSectorIdsString(allProductSectors, productSectorIdsFilterValue)
  const allProductSectorIds = useSelector(allKnownSortedProductSectorIdsSelector)
  const productSectorIds = productId ? getProductSectorIdsBelongingToProduct(allProductSectors, productId) : allProductSectorIds

  return (
    <SelectboxField
      label={Locale.translate(Translation.SC_FILTER_SECTOR_EQUALS)}
      dataTestId={'AdvancedDealSubscriptionFilters-Selectbox-Sector'}
      canClear={true}
      optionKeys={productSectorIds}
      getOption={getProductSectorNameById(allProductSectors)}
      value={getSubscriptionFilterValue(subscriptionFilters, 'productSectorId', FilterOperation.EQUALS)}
      onUpdate={handleUpdateFilterValue('productSectorId', FilterOperation.EQUALS)}
    />
  )
}
